import { useState } from 'react';
import { API_BASE } from './config';
import '../css/RefereePanel.css';

function RefereePanel({
  matchId,
  refreshAll,
  onFinish
}) {
  const [loading, setLoading] = useState(false);

  const endMatch = async winnerTeam => {
    if (loading) return;

    try {
      setLoading(true);

      const response = await fetch(`${API_BASE}/api/game-match/end`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          matchId,
          winnerTeam
        })
      });
      const responseData = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          responseData.message ||
          `End Match ไม่สำเร็จ (HTTP ${response.status})`
        );
      }

      const finishCallback = onFinish || refreshAll;
      if (finishCallback) {
        await finishCallback(responseData);
      }
    } catch (error) {
      console.error('END MATCH ERROR:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ref-panel">
      <h4 className="ref-title">🧑‍⚖️ Referee Panel</h4>

      <div className="ref-actions">
        <button
          type="button"
          className="ref-btn ref-team1"
          disabled={loading}
          onClick={() => endMatch('TEAM1')}
        >
          🏆 Team 1 Win
        </button>

        <button
          type="button"
          className="ref-btn ref-draw"
          disabled={loading}
          onClick={() => endMatch('DRAW')}
        >
          🤝 Draw
        </button>

        <button
          type="button"
          className="ref-btn ref-team2"
          disabled={loading}
          onClick={() => endMatch('TEAM2')}
        >
          🏆 Team 2 Win
        </button>
      </div>

      {loading && (
        <div className="ref-loading" role="status" aria-live="polite">
          Processing...
        </div>
      )}
    </div>
  );
}

export default RefereePanel;
